module.exports = __webpack_public_path__ + "4ab4240bee85b7f5c072c1ffe45f54a7.png";